package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.util.ExperienceMock
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import ir.hosen.resume.util.bps
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P

private val SCREEN_ID = ScreenItem.EXPERIENCE.id

@Composable
fun ExperienceRootScreen(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier.id(SCREEN_ID),
        contentAlignment = Alignment.Center
    ) {
        Content(modifier = modifier.width(60.vw))
    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(32.px)
    ) {
        Row(verticalAlignment = Alignment.Top) {
            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontSize(32.bps()),
                text = "Work Experience."
            )
            Img(
                src = "/portal_star.svg",
                attrs = Modifier.size(22.px).filter(invert(if (Theme.isDark) 0 else 1)).toAttrs()
            )
        }

        P(
            attrs = Modifier.fontSize(18.bps()).fontFamily(Res.String.ROBOTO_REGULAR).toAttrs()
        ) {
            SpanText(
                "I’m a Software Developer Engineer in Android Development with ",
                Modifier.color(Colors.Gray)
            )
            SpanText("+5 years ", Modifier.color(Theme.onBackgroundColor))
            SpanText("Experience.", Modifier.color(Colors.Gray))
        }

        SimpleGrid(
            numColumns(base = 1, sm = 3)
        ) {
            ExperienceMock.entries.forEach {
                JobInfoCard(experience = it)
            }
        }
    }

}

@Composable
private fun JobInfoCard(modifier: Modifier = Modifier, experience: ExperienceMock) {
    Box(
        modifier = modifier, contentAlignment = Alignment.TopStart
    ) {

        Column(
            modifier = Modifier.margin(24.px).padding(top = 32.px, left = 36.px, bottom = 28.px, right = 84.px)
                .border(width = 2.px, LineStyle.Solid, color = Colors.Gray).borderRadius(16.px)
                .minWidth(if (rememberBreakpoint() <= Breakpoint.SM) 182.px else 266.px),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {

            SpanText(
                modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_REGULAR).fontSize(13.bps()),
                text = experience.role
            )

            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_REGULAR)
                    .fontSize(32.bps()),
                text = experience.company
            )

            SpanText(
                modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_REGULAR).fontSize(13.bps()),
                text = experience.date
            )

        }

        SpanText(
            modifier = Modifier
                .margin(left = 4.cssRem, top = if (rememberBreakpoint() <= Breakpoint.SM) 12.px else 0.px)
                .color(Theme.onBackgroundColor)
                .fontFamily(Res.String.ROBOTO_REGULAR)
                .fontWeight(FontWeight.ExtraBold)
                .fontSize(48.bps()),
            text = experience.number
        )
    }
}